import { useState } from "react"
import { IoIosClose } from "react-icons/io";
import { main } from "../../../assets/coach-assets/constants/colors";
import { fontType } from "../../../assets/extras";

const ModalPlayers = ({ modalP, variables, setVariables, players, addNewPlayer }) => {

    const [searchP, setSearchP] = useState("")

    return (
        <>
            {
                variables.modalP && (
                    <div
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "rgba(0,0,0,0.5)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            zIndex: 1000,
                        }}
                    >
                        <div
                            style={{
                                backgroundColor: "white",
                                display: "flex",
                                flexDirection: "column",
                                width: "80%",
                                height: 400,
                                borderRadius: 20,
                                alignItems: "center",
                                padding: 20,
                                maxWidth: 600
                            }}
                        >
                            {/* Botón cerrar */}
                            <div 
                                style={{
                                    alignSelf: "flex-end",
                                    cursor: "pointer",
                                }}
                            >
                                <IoIosClose
                                    size={30}
                                    color="red"
                                    onClick={() =>
                                        setVariables((prev) => ({
                                            ...prev,
                                            modalP: false,
                                        }))
                                    }
                                />
                            </div>

                            <h2
                                style={{
                                    fontSize: 30,
                                    fontWeight: "bold",
                                    marginBottom: 20,
                                    fontFamily: fontType.title
                                }}
                            >
                                Jugadores
                            </h2>

                            {/* Input búsqueda */}
                            <input
                                type="text"
                                placeholder="Buscar jugador"
                                value={searchP}
                                onChange={(e) => setSearchP(e.target.value)}
                                style={{
                                    fontSize: 18,
                                    marginBottom: 20,
                                    padding: "10px",
                                    width: "100%",
                                    border: "1px solid #ccc",
                                    borderRadius: 5,
                                    color: "black",
                                }}
                            />

                            {/* Lista jugadores */}
                            <div
                                style={{
                                    overflowY: "auto",
                                    width: "100%",
                                }}
                            >
                                {(!searchP
                                    ? players
                                    : players.filter((v) =>
                                        v.nombre_jugador
                                            .toLowerCase()
                                            .normalize("NFD")
                                            .replace(/[\u0300-\u036f]/g, "")
                                            .includes(
                                                searchP
                                                    .toLowerCase()
                                                    .normalize("NFD")
                                                    .replace(/[\u0300-\u036f]/g, "")
                                            )
                                    )
                                ).map((item, index) => (
                                    <div
                                        key={item.id}
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            flexDirection: "row",
                                            padding: 10,
                                            border: `2px solid ${main}`,
                                            borderRadius: 5,
                                            marginBottom: 10,
                                            flexWrap: "wrap",
                                            cursor: "pointer",
                                            fontFamily: fontType.text
                                        }}
                                        onClick={() => {
                                            let p = players;
                                            p.splice(index, 1);

                                            setVariables((prev) => ({
                                                ...prev,
                                                allPlayers: p,
                                            }));

                                            addNewPlayer(
                                                item.id,
                                                item.nombre_jugador,
                                                index,
                                                item.asistencias,
                                                item.correo_jugador,
                                                item.edad_jugador,
                                                item.telefono_jugador
                                            );
                                        }}
                                    >
                                        <span style={{ fontSize: 18 }}>{item.nombre_jugador} </span>
                                        <span style={{ fontSize: 18 }}>{item.apellido_p_jugador}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )
            }
        </>
    )
}

export default ModalPlayers